import React from 'react'
import { logo } from '../../assets/imgs'

const Welcome = () => {
    return (
        <div className="dashRightView home_section" >
            <div className='d-flex flex-column ac-jc h-100 w-100'>
                <div className='text-center'>
                        <img src={logo} className="welcome-logo" alt="" />
                    <h2 className="f3 fs-sm-12 fs-md-18 fs-lg-20 fs-xl-23 fs-xxl-24 sec mt-2">
                        Welcome to Ziro Admin
                    </h2>
                </div>


            </div>
        </div>
    )
}

export default Welcome